import React from 'react';
import { useJWTAuth } from '../auth/JWTAuthContext';
import { useAccountLinking } from '../auth/useAccountLinking';
import { Link } from 'react-router-dom';

const AuthGuard = ({ children, fallback = null }) => {
  const { isAuthenticated: isJWTAuthenticated, user: jwtUser } = useJWTAuth();
  const { user: accountUser } = useAccountLinking();

  // Check if user is authenticated via JWT or account linking
  const isAuthenticated = isJWTAuthenticated() || accountUser;

  if (!isAuthenticated) {
    if (fallback) {
      return fallback;
    }

    // Default fallback - redirect to landing with login prompt
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="max-w-md mx-auto px-4 text-center">
          <div className="bg-gray-800 rounded-lg p-8 border border-gray-700">
            <div className="text-6xl mb-6">🔐</div>
            <h2 className="text-2xl font-bold text-white mb-4">Authentication Required</h2>
            <p className="text-gray-300 mb-6">
              Please connect your wallet and log in to access this page.
            </p>
            <div className="space-y-3">
              <Link
                to="/"
                className="block w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200"
              >
                Go to Homepage
              </Link>
              <p className="text-sm text-gray-400">
                Connect your wallet on the homepage to get started
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default AuthGuard;
